import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  FOOD_TABLE_RESERVATION_LIST,
  FOOD_TABLE_RESERVATION_LIST_TODAY,
  FOOD_TABLE_RESERVATION_LIST_TOMORROW,
  FOOD_TABLE_RESERVATION_LIST_FUTURE,
  FOOD_TABLE_RESERVATION_DATA,
  FOOD_TABLE_RESERVATION_CREATE,
  FOOD_TABLE_RESERVATION_IMPORT,
  FOOD_TABLE_RESERVATION_UPDATE,
  FOOD_TABLE_RESERVATION_DELETE,
  FOOD_TABLE_AREA_LIST,
  FOOD_TABLE_AREA_DATA,
  FOOD_TABLE_AREA_CREATE,
  FOOD_TABLE_AREA_UPDATE,
  FOOD_TABLE_AREA_DELETE,
  //Table
  FOOD_TABLE_LIST,
  FOOD_TABLE_DATA,
  FOOD_TABLE_CREATE,
  FOOD_TABLE_UPDATE,
  FOOD_TABLE_DELETE,
  //FOOD_TABLE_RESERVATION_SEARCH
  FOOD_TABLE_RESERVATION_SEARCH,
  FOOD_TABLE_DIARY_BLOCK_UPDATE,
  FOOD_TABLE_BLOCK_LIST,
  FOOD_TABLE_BLOCK_DATA,
  FOOD_TABLE_BLOCK_CREATE,
  FOOD_TABLE_BLOCK_DELETE,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN,
  //FOOD_TABLE_DIARY_RULE_LIST
  FOOD_TABLE_DIARY_RULE_LIST,
  FOOD_TABLE_DIARY_RULE_DATA,
  FOOD_TABLE_DIARY_RULE_CREATE,
  FOOD_TABLE_DIARY_RULE_UPDATE,
  FOOD_TABLE_DIARY_RULE_DELETE,
  FOOD_TABLE_FLOORPLAN_SAVE,
  FOOD_TABLE_REORDER,
  FOOD_TABLE_DIARY_RULE_REORDER,
  FOOD_TABLE_DIARY_RULE_SEARCH,
  FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT,
  //FOOD_TABLE_SEARCH
  FOOD_TABLE_SEARCH,
  FOOD_TABLE_AREA_SEARCH,
  FOOD_TABLE_RULE_SEARCH,
  //Booking Duration Rule
  FOOD_TABLE_DURATION_RULE_SEARCH,
  FOOD_TABLE_DURATION_RULE_DATA,
  FOOD_TABLE_DURATION_RULE_CREATE,
  FOOD_TABLE_DURATION_RULE_UPDATE,
  FOOD_TABLE_DURATION_RULE_DELETE,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER,
  FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY,
  FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER,
  // Join Tables
  FOOD_TABLE_JOIN_LIST,
  FOOD_TABLE_JOIN_DATA,
  FOOD_TABLE_JOIN_CREATE,
  FOOD_TABLE_JOIN_DELETE,
  FOOD_TABLE_JOIN_SEARCH,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE,
} from "./actionType";

import {
  foodTableReservationListSuccess,
  foodTableReservationListFail,
  foodTableReservationListTodaySuccess,
  foodTableReservationListTodayFail,
  foodTableReservationListTomorrowSuccess,
  foodTableReservationListTomorrowFail,
  foodTableReservationListFutureSuccess,
  foodTableReservationListFutureFail,
  foodTableReservationDataSuccess,
  foodTableReservationDataFail,
  foodTableReservationCreateSuccess,
  foodTableReservationCreateFail,
  foodTableReservationImportSuccess,
  foodTableReservationImportFail,
  foodTableReservationUpdateSuccess,
  foodTableReservationUpdateFail,
  foodTableReservationDeleteSuccess,
  foodTableReservationDeleteFail,
  foodTableAreaListSuccess,
  foodTableAreaListFail,
  foodTableAreaDataSuccess,
  foodTableAreaDataFail,
  foodTableAreaCreateSuccess,
  foodTableAreaCreateFail,
  foodTableAreaUpdateSuccess,
  foodTableAreaUpdateFail,
  foodTableAreaDeleteSuccess,
  foodTableAreaDeleteFail,
  //Table
  foodTableListSuccess,
  foodTableListFail,
  foodTableDataSuccess,
  foodTableDataFail,
  foodTableCreateSuccess,
  foodTableCreateFail,
  foodTableUpdateSuccess,
  foodTableUpdateFail,
  foodTableDeleteSuccess,
  foodTableDeleteFail,
  //FOOD_TABLE_RESERVATION_SEARCH
  foodTableReservationSearchSuccess,
  foodTableReservationSearchFail,
  //FOOD_TABLE_DIARY_BLOCK_UPDATE
  foodTableDiaryBlockUpdateSuccess,
  foodTableDiaryBlockUpdateFail,
  //FOOD_TABLE_BLOCK_LIST
  foodTableBlockListSuccess,
  foodTableBlockListFail,
  //FOOD_TABLE_BLOCK_DATA
  foodTableBlockDataSuccess,
  foodTableBlockDataFail,
  //FOOD_TABLE_BLOCK_CREATE
  foodTableBlockCreateSuccess,
  foodTableBlockCreateFail,
  //FOOD_TABLE_BLOCK_DELETE
  foodTableBlockDeleteSuccess,
  foodTableBlockDeleteFail,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE
  foodTableReservationTableAssignmentUpdateSuccess,
  foodTableReservationTableAssignmentUpdateFail,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL
  foodTableReservationTableAssignmentCancelSuccess,
  foodTableReservationTableAssignmentCancelFail,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN / _ASSIGN (Task 24607)
  foodTableReservationTableAssignmentUnassignSuccess,
  foodTableReservationTableAssignmentUnassignFail,
  foodTableReservationTableAssignmentAssignSuccess,
  foodTableReservationTableAssignmentAssignFail,
  //FOOD_TABLE_DIARY_RULE_LIST
  foodTableDiaryRuleListSuccess,
  foodTableDiaryRuleListFail,
  //FOOD_TABLE_DIARY_RULE_DATA
  foodTableDiaryRuleDataSuccess,
  foodTableDiaryRuleDataFail,
  //FOOD_TABLE_DIARY_RULE_CREATE
  foodTableDiaryRuleCreateSuccess,
  foodTableDiaryRuleCreateFail,
  //FOOD_TABLE_DIARY_RULE_UPDATE
  foodTableDiaryRuleUpdateSuccess,
  foodTableDiaryRuleUpdateFail,
  //FOOD_TABLE_DIARY_RULE_DELETE
  foodTableDiaryRuleDeleteSuccess,
  foodTableDiaryRuleDeleteFail,
  //FOOD_TABLE_DIARY_RULE_REORDER
  foodTableDiaryRuleReorderSuccess,
  foodTableDiaryRuleReorderFail,
  //FOOD_TABLE_FLOORPLAN_SAVE
  foodTableFloorPlanSaveSuccess,
  foodTableFloorPlanSaveFail,
  //FOOD_TABLE_REORDER
  foodTableReorderSuccess,
  foodTableReorderFail,
  //FOOD_TABLE_DIARY_RULE_SEARCH
  foodTableDiaryRuleSearchSuccess,
  foodTableDiaryRuleSearchFail,
  //FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS
  foodTableDiaryRuleSearchByTimeslotSuccess,
  foodTableDiaryRuleSearchByTimeslotFail,
  //FOOD_TABLE_SEARCH
  foodTableSearchSuccess,
  foodTableSearchFail,
  foodTableAreaSearchSuccess,
  foodTableAreaSearchFail,
  foodTableRuleSearchSuccess,
  foodTableRuleSearchFail,
  //Booking Duration Rule
  foodTableDurationRuleSearchSuccess,
  foodTableDurationRuleSearchFail,
  foodTableDurationRuleDataSuccess,
  foodTableDurationRuleDataFail,
  foodTableDurationRuleCreateSuccess,
  foodTableDurationRuleCreateFail,
  foodTableDurationRuleUpdateSuccess,
  foodTableDurationRuleUpdateFail,
  foodTableDurationRuleDeleteSuccess,
  foodTableDurationRuleDeleteFail,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
  foodTableReservationTableAssignmentPdfRunningOrderSuccess,
  foodTableReservationTableAssignmentPdfRunningOrderFail,
  //FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
  foodTableReservationCheckAvailabilitySuccess,
  foodTableReservationCheckAvailabilityFail,
  //FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
  foodTableReservationSearchSingleCustomerSuccess,
  foodTableReservationSearchSingleCustomerFail,
  // Join Tables
  foodTableJoinListSuccess,
  foodTableJoinListFail,
  foodTableJoinDataSuccess,
  foodTableJoinDataFail,
  foodTableJoinCreateSuccess,
  foodTableJoinCreateFail,
  foodTableJoinDeleteSuccess,
  foodTableJoinDeleteFail,
  foodTableJoinSearchSuccess,
  foodTableJoinSearchFail,
  // Floor Plan Object
  foodPreorderSiteLocationFloorPlanObjectListSuccess,
  foodPreorderSiteLocationFloorPlanObjectListFail,
  foodPreorderSiteLocationFloorPlanObjectDataSuccess,
  foodPreorderSiteLocationFloorPlanObjectDataFail,
  foodPreorderSiteLocationFloorPlanObjectCreateSuccess,
  foodPreorderSiteLocationFloorPlanObjectCreateFail,
  foodPreorderSiteLocationFloorPlanObjectUpdateSuccess,
  foodPreorderSiteLocationFloorPlanObjectUpdateFail,
  foodPreorderSiteLocationFloorPlanObjectDeleteSuccess,
  foodPreorderSiteLocationFloorPlanObjectDeleteFail,
} from "./action";

import {
  getFoodTableReservationList,
  getFoodTableReservationListToday,
  getFoodTableReservationListTomorrow,
  getFoodTableReservationListFuture,
  getFoodTableReservationData,
  postFoodTableReservationCreate,
  postFoodTableReservationImport,
  putFoodTableReservationUpdate,
  deleteFoodTableReservationDelete,
  getFoodTableAreaList,
  getFoodTableAreaData,
  postFoodTableAreaCreate,
  putFoodTableAreaUpdate,
  deleteFoodTableAreaDelete,
  //Table
  getFoodTableList,
  getFoodTableData,
  postFoodTableCreate,
  putFoodTableUpdate,
  deleteFoodTableDelete,
  //FOOD_TABLE_RESERVATION_SEARCH
  getFoodTableReservationSearch,
  //FOOD_TABLE_DIARY_BLOCK_UPDATE
  putFoodTableDiaryBlockUpdate,
  //FOOD_TABLE_BLOCK_LIST
  getFoodTableBlockList,
  //FOOD_TABLE_BLOCK_DATA
  getFoodTableBlockData,
  //FOOD_TABLE_BLOCK_CREATE
  postFoodTableBlockCreate,
  //FOOD_TABLE_BLOCK_DELETE
  deleteFoodTableBlockDelete,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE
  putFoodTableReservationTableAssignmentUpdate,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL
  putFoodTableReservationTableAssignmentCancel,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN / _ASSIGN (Task 24607)
  postFoodTableReservationTableAssignmentUnassign,
  postFoodTableReservationTableAssignmentAssign,
  //FOOD_TABLE_DIARY_RULE_LIST
  getFoodTableDiaryRuleList,
  //FOOD_TABLE_DIARY_RULE_DATA
  getFoodTableDiaryRuleData,
  //FOOD_TABLE_DIARY_RULE_CREATE
  postFoodTableDiaryRuleCreate,
  //FOOD_TABLE_DIARY_RULE_UPDATE
  putFoodTableDiaryRuleUpdate,
  //FOOD_TABLE_DIARY_RULE_DELETE
  deleteFoodTableDiaryRuleDelete,
  //FOOD_TABLE_DIARY_RULE_REORDER
  postFoodTableDiaryRuleReorder,
  putFoodTableFloorPlanAPI,
  putFoodTableReorderAPI,
  //FOOD_TABLE_DIARY_RULE_SEARCH
  getFoodTableDiaryRuleSearch,
  //FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS
  getFoodTableDiaryRuleSearchByTimeslot,
  //FOOD_TABLE_SEARCH
  getFoodTableSearchAPI,
  getFoodTableAreaSearchAPI,
  getFoodTableRuleSearchAPI,
  //Booking Duration Rule
  getFoodTableReservationDurationRuleData,
  postFoodTableReservationDurationRuleCreate,
  putFoodTableReservationDurationRuleUpdate,
  deleteFoodTableReservationDurationRuleDelete,
  postFoodTableReservationDurationRuleSearch,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
  getFoodTableReservationTableAssignmentPdfRunningOrder,
  //FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
  getFoodTableReservationCheckAvailability,
  //FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
  getFoodTableReservationSearchSingleCustomer,
  // Join Tables
  getFoodTableJoinList,
  getFoodTableJoinData,
  postFoodTableJoinCreate,
  deleteFoodTableJoinDelete,
  getFoodTableJoinSearch,
  // Floor Plan Object
  getFoodPreorderSiteLocationFloorPlanObjectList,
  getFoodPreorderSiteLocationFloorPlanObjectData,
  postFoodPreorderSiteLocationFloorPlanObjectCreate,
  putFoodPreorderSiteLocationFloorPlanObjectUpdate,
  deleteFoodPreorderSiteLocationFloorPlanObjectDelete,
} from "../../helpers/fakebackend_helper";

//FOOD_TABLE_RESERVATION_LIST
function* foodTableReservationListSaga() {
  try {
    const response = yield call(getFoodTableReservationList);
    yield put(foodTableReservationListSuccess(response));
  } catch (error) {
    yield put(foodTableReservationListFail(error));
  }
}

function* watchFoodTableReservationList() {
  yield takeEvery(FOOD_TABLE_RESERVATION_LIST, foodTableReservationListSaga);
}

//FOOD_TABLE_RESERVATION_LIST_TODAY
function* foodTableReservationListTodaySaga() {
  try {
    const response = yield call(getFoodTableReservationListToday);
    yield put(foodTableReservationListTodaySuccess(response));
  } catch (error) {
    yield put(foodTableReservationListTodayFail(error));
  }
}

function* watchFoodTableReservationListToday() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_LIST_TODAY,
    foodTableReservationListTodaySaga
  );
}

//FOOD_TABLE_RESERVATION_LIST_TOMORROW
function* foodTableReservationListTomorrowSaga() {
  try {
    const response = yield call(getFoodTableReservationListTomorrow);
    yield put(foodTableReservationListTomorrowSuccess(response));
  } catch (error) {
    yield put(foodTableReservationListTomorrowFail(error));
  }
}

function* watchFoodTableReservationListTomorrow() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_LIST_TOMORROW,
    foodTableReservationListTomorrowSaga
  );
}

//FOOD_TABLE_RESERVATION_LIST_FUTURE
function* foodTableReservationListFutureSaga() {
  try {
    const response = yield call(getFoodTableReservationListFuture);
    yield put(foodTableReservationListFutureSuccess(response));
  } catch (error) {
    yield put(foodTableReservationListFutureFail(error));
  }
}

function* watchFoodTableReservationListFuture() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_LIST_FUTURE,
    foodTableReservationListFutureSaga
  );
}

//FOOD_TABLE_RESERVATION_DATA
function* foodTableReservationDataSaga({ data }) {
  try {
    const response = yield call(getFoodTableReservationData, data);
    yield put(foodTableReservationDataSuccess(response));
  } catch (error) {
    yield put(foodTableReservationDataFail(error));
  }
}

function* watchFoodTableReservationData() {
  yield takeEvery(FOOD_TABLE_RESERVATION_DATA, foodTableReservationDataSaga);
}

//FOOD_TABLE_RESERVATION_CREATE
function* foodTableReservationCreateSaga({ data }) {
  try {
    const response = yield call(postFoodTableReservationCreate, data);
    yield put(foodTableReservationCreateSuccess(response));
  } catch (error) {
    yield put(foodTableReservationCreateFail(error));
  }
}

function* watchFoodTableReservationCreate() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_CREATE,
    foodTableReservationCreateSaga
  );
}

//FOOD_TABLE_RESERVATION_IMPORT
function* foodTableReservationImportSaga({ data }) {
  try {
    const response = yield call(postFoodTableReservationImport, data);
    yield put(foodTableReservationImportSuccess(response));
  } catch (error) {
    yield put(foodTableReservationImportFail(error));
  }
}

function* watchFoodTableReservationImport() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_IMPORT,
    foodTableReservationImportSaga
  );
}

//FOOD_TABLE_RESERVATION_UPDATE
function* foodTableReservationUpdateSaga({ data }) {
  try {
    const response = yield call(putFoodTableReservationUpdate, data);
    yield put(foodTableReservationUpdateSuccess(response));
  } catch (error) {
    yield put(foodTableReservationUpdateFail(error));
  }
}

function* watchFoodTableReservationUpdate() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_UPDATE,
    foodTableReservationUpdateSaga
  );
}

//FOOD_TABLE_RESERVATION_DELETE
function* foodTableReservationDeleteSaga({ data }) {
  try {
    const response = yield call(deleteFoodTableReservationDelete, data);
    yield put(foodTableReservationDeleteSuccess(response));
  } catch (error) {
    yield put(foodTableReservationDeleteFail(error));
  }
}

function* watchFoodTableReservationDelete() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_DELETE,
    foodTableReservationDeleteSaga
  );
}

//FOOD_TABLE_AREA_LIST
function* foodTableAreaListSaga() {
  try {
    const response = yield call(getFoodTableAreaList);
    yield put(foodTableAreaListSuccess(response));
  } catch (error) {
    yield put(foodTableAreaListFail(error));
  }
}

function* watchFoodTableAreaList() {
  yield takeEvery(FOOD_TABLE_AREA_LIST, foodTableAreaListSaga);
}

//FOOD_TABLE_AREA_DATA
function* foodTableAreaDataSaga({ data }) {
  try {
    const response = yield call(getFoodTableAreaData, data);
    yield put(foodTableAreaDataSuccess(response));
  } catch (error) {
    yield put(foodTableAreaDataFail(error));
  }
}

function* watchFoodTableAreaData() {
  yield takeEvery(FOOD_TABLE_AREA_DATA, foodTableAreaDataSaga);
}

//FOOD_TABLE_AREA_CREATE
function* foodTableAreaCreateSaga({ data }) {
  try {
    const response = yield call(postFoodTableAreaCreate, data);
    yield put(foodTableAreaCreateSuccess(response));
  } catch (error) {
    yield put(foodTableAreaCreateFail(error));
  }
}

function* watchFoodTableAreaCreate() {
  yield takeEvery(FOOD_TABLE_AREA_CREATE, foodTableAreaCreateSaga);
}

//FOOD_TABLE_AREA_UPDATE
function* foodTableAreaUpdateSaga({ data }) {
  try {
    const response = yield call(putFoodTableAreaUpdate, data);
    console.log("response", response);
    yield put(foodTableAreaUpdateSuccess(response));
  } catch (error) {
    yield put(foodTableAreaUpdateFail(error));
  }
}

function* watchFoodTableAreaUpdate() {
  yield takeEvery(FOOD_TABLE_AREA_UPDATE, foodTableAreaUpdateSaga);
}

//FOOD_TABLE_AREA_DELETE
function* foodTableAreaDeleteSaga({ data }) {
  try {
    const response = yield call(deleteFoodTableAreaDelete, data);
    yield put(foodTableAreaDeleteSuccess(response));
  } catch (error) {
    yield put(foodTableAreaDeleteFail(error));
  }
}

function* watchFoodTableAreaDelete() {
  yield takeEvery(FOOD_TABLE_AREA_DELETE, foodTableAreaDeleteSaga);
}

//Booking Duration Rule (FoodTableReservationDurationRule)
function* foodTableDurationRuleSearchSaga({ data }) {
  try {
    const response = yield call(
      postFoodTableReservationDurationRuleSearch,
      data
    );
    yield put(foodTableDurationRuleSearchSuccess(response));
  } catch (error) {
    yield put(foodTableDurationRuleSearchFail(error));
  }
}
function* watchFoodTableDurationRuleSearch() {
  yield takeEvery(FOOD_TABLE_DURATION_RULE_SEARCH, foodTableDurationRuleSearchSaga);
}

function* foodTableDurationRuleDataSaga({ data }) {
  try {
    const response = yield call(getFoodTableReservationDurationRuleData, data);
    yield put(foodTableDurationRuleDataSuccess(response));
  } catch (error) {
    yield put(foodTableDurationRuleDataFail(error));
  }
}
function* watchFoodTableDurationRuleData() {
  yield takeEvery(FOOD_TABLE_DURATION_RULE_DATA, foodTableDurationRuleDataSaga);
}

function* foodTableDurationRuleCreateSaga({ data }) {
  try {
    const response = yield call(
      postFoodTableReservationDurationRuleCreate,
      data
    );
    yield put(foodTableDurationRuleCreateSuccess(response));
  } catch (error) {
    yield put(foodTableDurationRuleCreateFail(error));
  }
}
function* watchFoodTableDurationRuleCreate() {
  yield takeEvery(FOOD_TABLE_DURATION_RULE_CREATE, foodTableDurationRuleCreateSaga);
}

function* foodTableDurationRuleUpdateSaga({ data }) {
  try {
    const response = yield call(
      putFoodTableReservationDurationRuleUpdate,
      data
    );
    yield put(foodTableDurationRuleUpdateSuccess(response));
  } catch (error) {
    yield put(foodTableDurationRuleUpdateFail(error));
  }
}
function* watchFoodTableDurationRuleUpdate() {
  yield takeEvery(FOOD_TABLE_DURATION_RULE_UPDATE, foodTableDurationRuleUpdateSaga);
}

function* foodTableDurationRuleDeleteSaga({ data }) {
  try {
    const response = yield call(
      deleteFoodTableReservationDurationRuleDelete,
      data
    );
    yield put(foodTableDurationRuleDeleteSuccess(response));
  } catch (error) {
    yield put(foodTableDurationRuleDeleteFail(error));
  }
}
function* watchFoodTableDurationRuleDelete() {
  yield takeEvery(FOOD_TABLE_DURATION_RULE_DELETE, foodTableDurationRuleDeleteSaga);
}

//FOOD_TABLE_LIST
function* foodTableListSaga() {
  try {
    const response = yield call(getFoodTableList);
    yield put(foodTableListSuccess(response));
  } catch (error) {
    yield put(foodTableListFail(error));
  }
}

function* watchFoodTableList() {
  yield takeEvery(FOOD_TABLE_LIST, foodTableListSaga);
}

//FOOD_TABLE_DATA
function* foodTableDataSaga({ data }) {
  try {
    const response = yield call(getFoodTableData, data);
    yield put(foodTableDataSuccess(response));
  } catch (error) {
    yield put(foodTableDataFail(error));
  }
}

function* watchFoodTableData() {
  yield takeEvery(FOOD_TABLE_DATA, foodTableDataSaga);
}

//FOOD_TABLE_CREATE
function* foodTableCreateSaga({ data }) {
  try {
    const response = yield call(postFoodTableCreate, data);
    yield put(foodTableCreateSuccess(response));
  } catch (error) {
    yield put(foodTableCreateFail(error));
  }
}

function* watchFoodTableCreate() {
  yield takeEvery(FOOD_TABLE_CREATE, foodTableCreateSaga);
}

//FOOD_TABLE_UPDATE
function* foodTableUpdateSaga({ data }) {
  try {
    const response = yield call(putFoodTableUpdate, data);
    yield put(foodTableUpdateSuccess(response));
  } catch (error) {
    yield put(foodTableUpdateFail(error));
  }
}

function* watchFoodTableUpdate() {
  yield takeEvery(FOOD_TABLE_UPDATE, foodTableUpdateSaga);
}

//FOOD_TABLE_DELETE
function* foodTableDeleteSaga({ data }) {
  try {
    const response = yield call(deleteFoodTableDelete, data);
    yield put(foodTableDeleteSuccess(response));
  } catch (error) {
    yield put(foodTableDeleteFail(error));
  }
}

function* watchFoodTableDelete() {
  yield takeEvery(FOOD_TABLE_DELETE, foodTableDeleteSaga);
}

//FOOD_TABLE_RESERVATION_SEARCH
function* foodTableReservationSearchSaga({ data }) {
  try {
    const response = yield call(getFoodTableReservationSearch, data);
    yield put(foodTableReservationSearchSuccess(response));
  } catch (error) {
    yield put(foodTableReservationSearchFail(error));
  }
}

function* watchFoodTableReservationSearch() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_SEARCH,
    foodTableReservationSearchSaga
  );
}

//FOOD_TABLE_DIARY_BLOCK_UPDATE
function* foodTableDiaryBlockUpdateSaga({ data }) {
  try {
    const response = yield call(putFoodTableDiaryBlockUpdate, data);
    yield put(foodTableDiaryBlockUpdateSuccess(response));
  } catch (error) {
    yield put(foodTableDiaryBlockUpdateFail(error));
  }
}

function* watchFoodTableDiaryBlockUpdate() {
  yield takeEvery(FOOD_TABLE_DIARY_BLOCK_UPDATE, foodTableDiaryBlockUpdateSaga);
}

//FOOD_TABLE_BLOCK_LIST
function* foodTableBlockListSaga() {
  try {
    const response = yield call(getFoodTableBlockList);
    yield put(foodTableBlockListSuccess(response));
  } catch (error) {
    yield put(foodTableBlockListFail(error));
  }
}

function* watchFoodTableBlockList() {
  yield takeEvery(FOOD_TABLE_BLOCK_LIST, foodTableBlockListSaga);
}

//FOOD_TABLE_BLOCK_DATA
function* foodTableBlockDataSaga({ data }) {
  try {
    const response = yield call(getFoodTableBlockData, data);
    yield put(foodTableBlockDataSuccess(response));
  } catch (error) {
    yield put(foodTableBlockDataFail(error));
  }
}

function* watchFoodTableBlockData() {
  yield takeEvery(FOOD_TABLE_BLOCK_DATA, foodTableBlockDataSaga);
}

//FOOD_TABLE_BLOCK_CREATE
function* foodTableBlockCreateSaga({ data }) {
  try {
    const response = yield call(postFoodTableBlockCreate, data);
    yield put(foodTableBlockCreateSuccess(response));
  } catch (error) {
    yield put(foodTableBlockCreateFail(error));
  }
}

function* watchFoodTableBlockCreate() {
  yield takeEvery(FOOD_TABLE_BLOCK_CREATE, foodTableBlockCreateSaga);
}

//FOOD_TABLE_BLOCK_DELETE
function* foodTableBlockDeleteSaga({ data }) {
  try {
    const response = yield call(deleteFoodTableBlockDelete, data);
    yield put(foodTableBlockDeleteSuccess(response));
  } catch (error) {
    yield put(foodTableBlockDeleteFail(error));
  }
}

function* watchFoodTableBlockDelete() {
  yield takeEvery(FOOD_TABLE_BLOCK_DELETE, foodTableBlockDeleteSaga);
}

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE
function* foodTableReservationTableAssignmentUpdateSaga({ data }) {
  try {
    const response = yield call(
      putFoodTableReservationTableAssignmentUpdate,
      data
    );
    yield put(foodTableReservationTableAssignmentUpdateSuccess(response));
  } catch (error) {
    yield put(foodTableReservationTableAssignmentUpdateFail(error));
  }
}

function* watchFoodTableReservationTableAssignmentUpdate() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE,
    foodTableReservationTableAssignmentUpdateSaga
  );
}

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL
function* foodTableReservationTableAssignmentCancelSaga({ data }) {
  try {
    const response = yield call(
      putFoodTableReservationTableAssignmentCancel,
      data
    );
    yield put(foodTableReservationTableAssignmentCancelSuccess(response));
  } catch (error) {
    yield put(foodTableReservationTableAssignmentCancelFail(error));
  }
}

function* watchFoodTableReservationTableAssignmentCancel() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL,
    foodTableReservationTableAssignmentCancelSaga
  );
}

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN (Task 24607)
function* foodTableReservationTableAssignmentUnassignSaga({ data }) {
  try {
    const response = yield call(
      postFoodTableReservationTableAssignmentUnassign,
      data
    );
    yield put(foodTableReservationTableAssignmentUnassignSuccess(response));
  } catch (error) {
    yield put(foodTableReservationTableAssignmentUnassignFail(error));
  }
}

function* watchFoodTableReservationTableAssignmentUnassign() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN,
    foodTableReservationTableAssignmentUnassignSaga
  );
}

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN (Task 24607)
function* foodTableReservationTableAssignmentAssignSaga({ data }) {
  try {
    const response = yield call(
      postFoodTableReservationTableAssignmentAssign,
      data
    );
    yield put(foodTableReservationTableAssignmentAssignSuccess(response));
  } catch (error) {
    yield put(foodTableReservationTableAssignmentAssignFail(error));
  }
}

function* watchFoodTableReservationTableAssignmentAssign() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN,
    foodTableReservationTableAssignmentAssignSaga
  );
}

//FOOD_TABLE_DIARY_RULE_LIST
function* foodTableDiaryRuleListSaga() {
  try {
    const response = yield call(getFoodTableDiaryRuleList);
    yield put(foodTableDiaryRuleListSuccess(response));
  } catch (error) {
    yield put(foodTableDiaryRuleListFail(error));
  }
}

function* watchFoodTableDiaryRuleList() {
  yield takeEvery(FOOD_TABLE_DIARY_RULE_LIST, foodTableDiaryRuleListSaga);
}

//FOOD_TABLE_DIARY_RULE_DATA
function* foodTableDiaryRuleDataSaga({ data }) {
  try {
    const response = yield call(getFoodTableDiaryRuleData, data);
    yield put(foodTableDiaryRuleDataSuccess(response));
  } catch (error) {
    yield put(foodTableDiaryRuleDataFail(error));
  }
}

function* watchFoodTableDiaryRuleData() {
  yield takeEvery(FOOD_TABLE_DIARY_RULE_DATA, foodTableDiaryRuleDataSaga);
}

//FOOD_TABLE_DIARY_RULE_CREATE
function* foodTableDiaryRuleCreateSaga({ data }) {
  try {
    const response = yield call(postFoodTableDiaryRuleCreate, data);
    yield put(foodTableDiaryRuleCreateSuccess(response));
  } catch (error) {
    yield put(foodTableDiaryRuleCreateFail(error));
  }
}

function* watchFoodTableDiaryRuleCreate() {
  yield takeEvery(FOOD_TABLE_DIARY_RULE_CREATE, foodTableDiaryRuleCreateSaga);
}

//FOOD_TABLE_DIARY_RULE_UPDATE
function* foodTableDiaryRuleUpdateSaga({ data }) {
  try {
    const response = yield call(putFoodTableDiaryRuleUpdate, data);
    yield put(foodTableDiaryRuleUpdateSuccess(response));
  } catch (error) {
    yield put(foodTableDiaryRuleUpdateFail(error));
  }
}

function* watchFoodTableDiaryRuleUpdate() {
  yield takeEvery(FOOD_TABLE_DIARY_RULE_UPDATE, foodTableDiaryRuleUpdateSaga);
}

//FOOD_TABLE_DIARY_RULE_DELETE
function* foodTableDiaryRuleDeleteSaga({ data }) {
  try {
    const response = yield call(deleteFoodTableDiaryRuleDelete, data);
    yield put(foodTableDiaryRuleDeleteSuccess(response));
  } catch (error) {
    yield put(foodTableDiaryRuleDeleteFail(error));
  }
}

function* watchFoodTableDiaryRuleDelete() {
  yield takeEvery(FOOD_TABLE_DIARY_RULE_DELETE, foodTableDiaryRuleDeleteSaga);
}

//FOOD_TABLE_REORDER (Task 24634)
function* foodTableReorderSaga({ data }) {
  try {
    const response = yield call(putFoodTableReorderAPI, data);
    yield put(foodTableReorderSuccess(response));
  } catch (error) {
    yield put(foodTableReorderFail(error));
  }
}

function* watchFoodTableReorder() {
  yield takeEvery(FOOD_TABLE_REORDER, foodTableReorderSaga);
}

//FOOD_TABLE_FLOORPLAN_SAVE (Task 24625)
function* foodTableFloorPlanSaveSaga({ data }) {
  try {
    const response = yield call(putFoodTableFloorPlanAPI, data);
    yield put(foodTableFloorPlanSaveSuccess(response));
  } catch (error) {
    yield put(foodTableFloorPlanSaveFail(error));
  }
}

function* watchFoodTableFloorPlanSave() {
  yield takeEvery(FOOD_TABLE_FLOORPLAN_SAVE, foodTableFloorPlanSaveSaga);
}

//FOOD_TABLE_DIARY_RULE_REORDER
function* foodTableDiaryRuleReorderSaga({ data }) {
  try {
    const response = yield call(postFoodTableDiaryRuleReorder, data);
    yield put(foodTableDiaryRuleReorderSuccess(response));
  } catch (error) {
    yield put(foodTableDiaryRuleReorderFail(error));
  }
}

function* watchFoodTableDiaryRuleReorder() {
  yield takeEvery(FOOD_TABLE_DIARY_RULE_REORDER, foodTableDiaryRuleReorderSaga);
}

//FOOD_TABLE_DIARY_RULE_SEARCH
function* foodTableDiaryRuleSearchSaga({ data }) {
  try {
    const response = yield call(getFoodTableDiaryRuleSearch, data);
    yield put(foodTableDiaryRuleSearchSuccess(response));
  } catch (error) {
    yield put(foodTableDiaryRuleSearchFail(error));
  }
}

function* watchFoodTableDiaryRuleSearch() {
  yield takeEvery(FOOD_TABLE_DIARY_RULE_SEARCH, foodTableDiaryRuleSearchSaga);
}

//FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS
function* foodTableDiaryRuleSearchByTimeslotSaga({ data }) {
  try {
    const response = yield call(getFoodTableDiaryRuleSearchByTimeslot, data);
    yield put(foodTableDiaryRuleSearchByTimeslotSuccess(response));
  } catch (error) {
    yield put(foodTableDiaryRuleSearchByTimeslotFail(error));
  }
}

function* watchFoodTableDiaryRuleSearchByTimeslot() {
  yield takeEvery(
    FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT,
    foodTableDiaryRuleSearchByTimeslotSaga
  );
}

//FOOD_TABLE_SEARCH
function* foodTableSearchSaga({ data }) {
  try {
    const response = yield call(getFoodTableSearchAPI, data);
    yield put(foodTableSearchSuccess(response));
  } catch (error) {
    yield put(foodTableSearchFail(error));
  }
}

function* watchFoodTableSearch() {
  yield takeEvery(FOOD_TABLE_SEARCH, foodTableSearchSaga);
}

//FOOD_TABLE_AREA_SEARCH
function* foodTableAreaSearchSaga({ data }) {
  try {
    const response = yield call(getFoodTableAreaSearchAPI, data);
    yield put(foodTableAreaSearchSuccess(response));
  } catch (error) {
    yield put(foodTableAreaSearchFail(error));
  }
}
function* watchFoodTableAreaSearch() {
  yield takeEvery(FOOD_TABLE_AREA_SEARCH, foodTableAreaSearchSaga);
}

//FOOD_TABLE_RULE_SEARCH
function* foodTableRuleSearchSaga({ data }) {
  try {
    const response = yield call(getFoodTableRuleSearchAPI, data);
    yield put(foodTableRuleSearchSuccess(response));
  } catch (error) {
    yield put(foodTableRuleSearchFail(error));
  }
}
function* watchFoodTableRuleSearch() {
  yield takeEvery(FOOD_TABLE_RULE_SEARCH, foodTableRuleSearchSaga);
}

//FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
function* foodTableReservationTableAssignmentPdfRunningOrderSaga({ data }) {
  try {
    const response = yield call(
      getFoodTableReservationTableAssignmentPdfRunningOrder,
      data
    );
    yield put(
      foodTableReservationTableAssignmentPdfRunningOrderSuccess(response)
    );
  } catch (error) {
    yield put(foodTableReservationTableAssignmentPdfRunningOrderFail(error));
  }
}

function* watchFoodTableReservationTableAssignmentPdfRunningOrder() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER,
    foodTableReservationTableAssignmentPdfRunningOrderSaga
  );
}
//FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
function* foodTableReservationCheckAvailabilitySaga({ data }) {
  try {
    const response = yield call(getFoodTableReservationCheckAvailability, data);
    yield put(foodTableReservationCheckAvailabilitySuccess(response));
  } catch (error) {
    yield put(foodTableReservationCheckAvailabilityFail(error));
  }
}

function* watchFoodTableReservationCheckAvailability() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY,
    foodTableReservationCheckAvailabilitySaga
  );
}
//FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
function* foodTableReservationSearchSingleCustomerSaga({ data }) {
  try {
    const response = yield call(
      getFoodTableReservationSearchSingleCustomer,
      data
    );
    yield put(foodTableReservationSearchSingleCustomerSuccess(response));
  } catch (error) {
    yield put(foodTableReservationSearchSingleCustomerFail(error));
  }
}
function* watchFoodTableReservationSearchSingleCustomer() {
  yield takeEvery(
    FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER,
    foodTableReservationSearchSingleCustomerSaga
  );
}
// Join Tables
//FOOD_TABLE_JOIN_LIST
function* foodTableJoinListSaga() {
  try {
    const response = yield call(getFoodTableJoinList);
    yield put(foodTableJoinListSuccess(response));
  } catch (error) {
    yield put(foodTableJoinListFail(error));
  }
}

function* watchFoodTableJoinList() {
  yield takeEvery(FOOD_TABLE_JOIN_LIST, foodTableJoinListSaga);
}

//FOOD_TABLE_JOIN_DATA
function* foodTableJoinDataSaga({ data }) {
  try {
    const response = yield call(getFoodTableJoinData, data);
    yield put(foodTableJoinDataSuccess(response));
  } catch (error) {
    yield put(foodTableJoinDataFail(error));
  }
}

function* watchFoodTableJoinData() {
  yield takeEvery(FOOD_TABLE_JOIN_DATA, foodTableJoinDataSaga);
}

//FOOD_TABLE_JOIN_CREATE
function* foodTableJoinCreateSaga({ data }) {
  try {
    const response = yield call(postFoodTableJoinCreate, data);
    yield put(foodTableJoinCreateSuccess(response));
  } catch (error) {
    yield put(foodTableJoinCreateFail(error));
  }
}

function* watchFoodTableJoinCreate() {
  yield takeEvery(FOOD_TABLE_JOIN_CREATE, foodTableJoinCreateSaga);
}

//FOOD_TABLE_JOIN_DELETE
function* foodTableJoinDeleteSaga({ data }) {
  try {
    const response = yield call(deleteFoodTableJoinDelete, data);
    yield put(foodTableJoinDeleteSuccess(response));
  } catch (error) {
    yield put(foodTableJoinDeleteFail(error));
  }
}

function* watchFoodTableJoinDelete() {
  yield takeEvery(FOOD_TABLE_JOIN_DELETE, foodTableJoinDeleteSaga);
}

//FOOD_TABLE_JOIN_SEARCH
function* foodTableJoinSearchSaga({ data }) {
  try {
    const response = yield call(getFoodTableJoinSearch, data);
    yield put(foodTableJoinSearchSuccess(response));
  } catch (error) {
    yield put(foodTableJoinSearchFail(error));
  }
}

function* watchFoodTableJoinSearch() {
  yield takeEvery(FOOD_TABLE_JOIN_SEARCH, foodTableJoinSearchSaga);
}

// Floor Plan Object
function* foodPreorderSiteLocationFloorPlanObjectListSaga() {
  try {
    const response = yield call(getFoodPreorderSiteLocationFloorPlanObjectList);
    yield put(foodPreorderSiteLocationFloorPlanObjectListSuccess(response));
  } catch (error) {
    yield put(foodPreorderSiteLocationFloorPlanObjectListFail(error));
  }
}

function* watchFoodPreorderSiteLocationFloorPlanObjectList() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST,
    foodPreorderSiteLocationFloorPlanObjectListSaga
  );
}

function* foodPreorderSiteLocationFloorPlanObjectDataSaga({ data }) {
  try {
    const response = yield call(getFoodPreorderSiteLocationFloorPlanObjectData, data);
    yield put(foodPreorderSiteLocationFloorPlanObjectDataSuccess(response));
  } catch (error) {
    yield put(foodPreorderSiteLocationFloorPlanObjectDataFail(error));
  }
}

function* watchFoodPreorderSiteLocationFloorPlanObjectData() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA,
    foodPreorderSiteLocationFloorPlanObjectDataSaga
  );
}

function* foodPreorderSiteLocationFloorPlanObjectCreateSaga({ data }) {
  try {
    const response = yield call(postFoodPreorderSiteLocationFloorPlanObjectCreate, data);
    yield put(foodPreorderSiteLocationFloorPlanObjectCreateSuccess(response));
  } catch (error) {
    yield put(foodPreorderSiteLocationFloorPlanObjectCreateFail(error));
  }
}

function* watchFoodPreorderSiteLocationFloorPlanObjectCreate() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE,
    foodPreorderSiteLocationFloorPlanObjectCreateSaga
  );
}

function* foodPreorderSiteLocationFloorPlanObjectUpdateSaga({ data }) {
  try {
    const response = yield call(putFoodPreorderSiteLocationFloorPlanObjectUpdate, data);
    yield put(foodPreorderSiteLocationFloorPlanObjectUpdateSuccess(response));
  } catch (error) {
    yield put(foodPreorderSiteLocationFloorPlanObjectUpdateFail(error));
  }
}

function* watchFoodPreorderSiteLocationFloorPlanObjectUpdate() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE,
    foodPreorderSiteLocationFloorPlanObjectUpdateSaga
  );
}

function* foodPreorderSiteLocationFloorPlanObjectDeleteSaga({ data }) {
  try {
    const response = yield call(deleteFoodPreorderSiteLocationFloorPlanObjectDelete, data);
    yield put(foodPreorderSiteLocationFloorPlanObjectDeleteSuccess(response));
  } catch (error) {
    yield put(foodPreorderSiteLocationFloorPlanObjectDeleteFail(error));
  }
}

function* watchFoodPreorderSiteLocationFloorPlanObjectDelete() {
  yield takeEvery(
    FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE,
    foodPreorderSiteLocationFloorPlanObjectDeleteSaga
  );
}

// Root saga

function* FoodTable() {
  yield all([
    fork(watchFoodTableReservationList),
    fork(watchFoodTableReservationListToday),
    fork(watchFoodTableReservationListTomorrow),
    fork(watchFoodTableReservationListFuture),
    fork(watchFoodTableReservationData),
    fork(watchFoodTableReservationCreate),
    fork(watchFoodTableReservationImport),
    fork(watchFoodTableReservationUpdate),
    fork(watchFoodTableReservationDelete),
    fork(watchFoodTableAreaList),
    fork(watchFoodTableAreaData),
    fork(watchFoodTableAreaCreate),
    fork(watchFoodTableAreaUpdate),
    fork(watchFoodTableAreaDelete),
    //Table
    fork(watchFoodTableList),
    fork(watchFoodTableData),
    fork(watchFoodTableCreate),
    fork(watchFoodTableUpdate),
    fork(watchFoodTableDelete),
    //FOOD_TABLE_RESERVATION_SEARCH
    fork(watchFoodTableReservationSearch),
    //FOOD_TABLE_DIARY_BLOCK_UPDATE
    fork(watchFoodTableDiaryBlockUpdate),
    //FOOD_TABLE_BLOCK_LIST
    fork(watchFoodTableBlockList),
    //FOOD_TABLE_BLOCK_DATA
    fork(watchFoodTableBlockData),
    //FOOD_TABLE_BLOCK_CREATE
    fork(watchFoodTableBlockCreate),
    //FOOD_TABLE_BLOCK_DELETE
    fork(watchFoodTableBlockDelete),
    //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE
    fork(watchFoodTableReservationTableAssignmentUpdate),
    //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL
    fork(watchFoodTableReservationTableAssignmentCancel),
    fork(watchFoodTableReservationTableAssignmentUnassign),
    fork(watchFoodTableReservationTableAssignmentAssign),
    //FOOD_TABLE_DIARY_RULE_LIST
    fork(watchFoodTableDiaryRuleList),
    //FOOD_TABLE_DIARY_RULE_DATA
    fork(watchFoodTableDiaryRuleData),
    //FOOD_TABLE_DIARY_RULE_CREATE
    fork(watchFoodTableDiaryRuleCreate),
    //FOOD_TABLE_DIARY_RULE_UPDATE
    fork(watchFoodTableDiaryRuleUpdate),
    //FOOD_TABLE_DIARY_RULE_DELETE
    fork(watchFoodTableDiaryRuleDelete),
    //FOOD_TABLE_DIARY_RULE_REORDER
    fork(watchFoodTableDiaryRuleReorder),
    //FOOD_TABLE_FLOORPLAN_SAVE
    fork(watchFoodTableFloorPlanSave),
    //FOOD_TABLE_REORDER
    fork(watchFoodTableReorder),
    //FOOD_TABLE_DIARY_RULE_SEARCH
    fork(watchFoodTableDiaryRuleSearch),
    //FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS
    fork(watchFoodTableDiaryRuleSearchByTimeslot),
    //FOOD_TABLE_SEARCH
    fork(watchFoodTableSearch),
    fork(watchFoodTableAreaSearch),
    fork(watchFoodTableRuleSearch),
    //Booking Duration Rule
    fork(watchFoodTableDurationRuleSearch),
    fork(watchFoodTableDurationRuleData),
    fork(watchFoodTableDurationRuleCreate),
    fork(watchFoodTableDurationRuleUpdate),
    fork(watchFoodTableDurationRuleDelete),
    //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
    fork(watchFoodTableReservationTableAssignmentPdfRunningOrder),
    //FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
    fork(watchFoodTableReservationCheckAvailability),
    //FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
    fork(watchFoodTableReservationSearchSingleCustomer),
    // Join Tables
    fork(watchFoodTableJoinList),
    fork(watchFoodTableJoinData),
    fork(watchFoodTableJoinCreate),
    fork(watchFoodTableJoinDelete),
    fork(watchFoodTableJoinSearch),
    // Floor Plan Object
    fork(watchFoodPreorderSiteLocationFloorPlanObjectList),
    fork(watchFoodPreorderSiteLocationFloorPlanObjectData),
    fork(watchFoodPreorderSiteLocationFloorPlanObjectCreate),
    fork(watchFoodPreorderSiteLocationFloorPlanObjectUpdate),
    fork(watchFoodPreorderSiteLocationFloorPlanObjectDelete),
  ]);
}

export default FoodTable;
